<template>
  <header id="header" class="header">
    <div class="container">
      <div class="headerInner">
        <div 
          class="burger" 
          @click="burgerToggle" 
          :class="{ burgerActive: navIsActive }"
        >
          <div class="burgerLine"></div>
          <div class="burgerLine"></div>
          <div class="burgerLine"></div>
        </div>
        <div class="inner" :class="{ innerShow: navIsActive }">
          <div class="socials">
            <a
              target="_blank"
              href="https://t.me/Timofey91"
              class="socialsLink"
            >
              <img src="/my-cv/img/telegram.svg" alt="Телеграм" />
            </a>
            <a
              target="_blank"
              href="https://github.com/Brushteyn"
              class="socialsLink"
            >
              <img src="/my-cv/img/git.svg" alt="GitHub" />
            </a>
            <a
              href="mailto:brushteyntimofey@gmail.com"
              class="socialsLink"
            >
              <img src="/my-cv/img/gmail.svg" alt="Gmail" />
            </a>
          </div>
          <nav class="nav">
            <select class="lang-select" v-model="$i18n.locale">
              <option @click="switchLocale(locale)" v-for="locale in locales" :key="locale" :value="locale">
                {{ locale }}
              </option>
            </select>
            <router-link 
              to="/my-cv" 
              class="navLink active" 
              @click="burgerClose"
            >
              {{ $t('main') }}
            </router-link>
            <router-link 
              to="/my-cv/about" 
              class="navLink" 
              @click="burgerClose"
            >
              {{ $t('about_me') }}
            </router-link>
            <router-link 
              to="/my-cv/portfolio" 
              class="navLink" 
              @click="burgerClose"
            >
              {{ $t('portfolio') }}
            </router-link>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      navIsActive: false,
      body: document.querySelector('body'),
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
    }
  },
  methods: {
    burgerToggle() {
      this.navIsActive = !this.navIsActive;
      this.body.classList.toggle("overflow");
    },
    burgerClose() {
      this.navIsActive = false;
      this.body.classList.remove("overflow");
    },
    switchLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale
      }
    }
  }
};
</script>

<style lang="scss">
.header {
  height: 100px;
  z-index: 100;
  align-items: center;
  display: flex;

  @media (max-width: 425px) {
    height: 60px;
  }

  .headerInner {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .inner {
      width: 100%;
      display: flex;
      justify-content: space-between;

      @media (max-width: 768px) {
        margin-left: -100%;
        flex-direction: column-reverse;
        align-items: center !important;
        height: 100vh !important;
        width: 100%;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: $white;
        text-align: center;
        transition: 0.3s;
        z-index: 1;
      }

      .socials {
        display: flex;
        align-items: center;

        @media (max-width: 768px) {
          margin-bottom: 50px;
        }

        .socialsLink {
          display: flex;
          align-items: center;
          width: 25px;

          &:not(:last-child) {
            margin-right: 25px;
          }

          img {
            width: 22px;
            height: 22px;
            opacity: 0.5;
            transition: 0.2s ease-in-out;

            &:hover {
              opacity: 1;
            }

            @media (max-width: 768px) {
              opacity: 1;
            }
          }
        }
      }

      .nav {
        display: flex;
        align-items: center;

        @media (max-width: 768px) {
          flex-direction: column;
          justify-content: center;
          height: 100%;
        }

        .lang-select {
          width: 50px;
          height: 30px;
          margin-right: 30px;
          font-size: 16px;
          text-transform: capitalize;
          cursor: pointer;

          option {
            border-radius: 0;
          }

          &:focus-visible {
            outline: none;
          }

          @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
          }
        }

        .navLink {
          text-decoration: none;
          opacity: 0.5;
          transition: 0.2s ease-in-out;

          &:not(:last-child) {
            margin-right: 30px;

            @media (max-width: 768px) {
              margin: 0 0 20px 0;
            }
          }

          &:hover {
            opacity: 1;
            color: inherit;
            text-decoration: none;
          }

          &.router-link-active {
            opacity: 1;
            position: relative;
          }
        }

        .navLinkActive {
          opacity: 1;
        }
      }
    }

    .innerShow {
      transition: 0.3s;
      margin-left: 0;
    }

    .burger {
      display: none;
      z-index: 10;
      margin-left: auto;

      .burgerLine {
        transition: 0.3s ease-in-out;
        width: 25px;
        height: 2px;
        display: block;
        background: $black;

        &:not(:last-child) {
          margin-bottom: 5px;
        }
      }

      @media (max-width: 768px) {
        display: block;
      }
    }

    .burgerActive {
      .burgerLine {
        margin: 0 !important;

        &:first-child {
          transform: rotate(-135deg);
        }

        &:nth-child(2) {
          opacity: 0;
        }

        &:last-child {
          margin-top: -4px !important;
          transform: rotate(135deg);
        }
      }
    }
  }
}
</style>